import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import moment from 'moment';
import 'font-awesome/css/font-awesome.min.css';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import { LinkIcon } from '../../../bombiix-icon';


/**
 * The app shell paints a 48px fixed sidebar over the page, which Popper cannot
 * measure: centred on a left-column card's link icon, this panel rendered with
 * its first 15px underneath that rail. 56px is the rail plus the 8px gutter the
 * rest of the page keeps.
 */
const POPPER_CONFIG = {
  modifiers: [{ name: 'preventOverflow', options: { padding: { top: 8, right: 8, bottom: 8, left: 56 } } }],
};

function BtnClock({ item, isDisabled, isBulk, onIntervalChange, intervalTime, onSubmitRequest, iconClass, btnClass, iconSize = 24, loading, dropdownUp }) {
  const { t } = useTranslation('common');
  const statusClass = iconClass ? `partner-link-status--${iconClass}` : '';


  const tagsOptions = [
    {
      label: t('BTN_CLOCK.INSTANT_REQUEST'),
      value: 'instant',
      isDisabled: false,
    },
    {
      label: t('BTN_CLOCK.NO_INTERVAL'),
      value: 'no',
      isDisabled: isBulk ? false : !item?.factoryLink?.updatedAt,
    },
    {
      label: t('BTN_CLOCK.THREE_MONTHS'),
      value: '3',
      isDisabled: false,
    },
    {
      label: t('BTN_CLOCK.SIX_MONTHS'),
      value: '6',
      isDisabled: false,
    },
    {
      label: t('BTN_CLOCK.NINE_MONTHS'),
      value: '9',
      isDisabled: false,
    },
  ];

  return (
    <CustomTooltip tooltipText="Send Factory Link" placement="top">
      <button
        type="button"
        disabled={isDisabled}
        className={`${btnClass} ${statusClass}`.trim()}
        aria-label={t('BTN_CLOCK.SEND_FACTORY_LINK')}
      >
        <OverlayTrigger
          placement={dropdownUp ? 'top' : 'bottom'}
          trigger="click"
          rootClose
          popperConfig={POPPER_CONFIG}
          overlay={
            <Popover className="partner-link-menu">
              <Popover.Content>
                <p className="partner-link-menu__title">{t('BTN_CLOCK.SELECT_RECURRING_PERIOD')}</p>
                <div className="partner-link-menu__options">
                  {tagsOptions.map((option) => (
                    <button
                      key={option.value}
                      type="button"
                      disabled={option.isDisabled}
                      className={`partner-link-menu__option${intervalTime === option.value ? ' is-selected' : ''}`}
                      onClick={(event) => {
                        event.stopPropagation();
                        onIntervalChange(option);
                      }}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
                <dl className="partner-link-menu__meta">
                  <div className="partner-link-menu__meta-row">
                    <dt>{t('BTN_CLOCK.LAST_UPDATE')}</dt>
                    <dd>{item?.factoryLink?.updatedAt ? moment(item.factoryLink.updatedAt).format('DD-MM-YYYY, h:mm A') : '--'}</dd>
                  </div>
                  <div className="partner-link-menu__meta-row">
                    <dt>{t('BTN_CLOCK.NEXT_UPDATE')}</dt>
                    <dd>{item?.factoryLink?.endDate ? moment(item.factoryLink.endDate).format('DD-MM-YYYY, h:mm A') : '--'}</dd>
                  </div>
                </dl>
                <div className="partner-link-menu__footer">
                  <button type="button" onClick={onSubmitRequest} className="bombiix-btn btn-blue" disabled={loading}>
                    {loading ? <i className="fa fa-spinner fa-spin" /> : t('BTN_CLOCK.SUBMIT')}
                  </button>
                </div>
              </Popover.Content>
            </Popover>
          }
        >
          <LinkIcon size={iconSize} />
        </OverlayTrigger>
      </button>
    </CustomTooltip>
  );
}

export default BtnClock;
